import React, { useCallback, useMemo } from 'react';
import InputDate from '../../../../../components/form/elements/date';
import { CalendarImage } from '../../../../../assets/icons/insex';
import { useTranslation } from 'react-i18next';

interface Props {
  rest: object;
}

function PeriodDates({ rest }: Props) {
  const { t } = useTranslation();

  const transKeyPrefix = 'pages.livestock.animals_and_events.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);

  const DateFrom = useMemo(
    () =>
      InputDate('date_from', null, null, null, true, CalendarImage, true, true),
    []
  );

  const DateTo = useMemo(
    () =>
      InputDate('date_to', null, null, null, true, CalendarImage, true, true),
    []
  );

  return (
    <div>
      <div className="flex flex-row justify-between my-1">
        <label className="basis-1/2 text-[#6F6F6F]">
          {tp('events.grazing.periods')}{' '}
          <span className="text-[#12589F] font-bold">*</span>
        </label>
      </div>
      <div className="flex gap-1">
        <span className="flex-1">
          <DateFrom {...rest} />
        </span>
        <span className="flex-1">
          <DateTo {...rest} />
        </span>
      </div>
    </div>
  );
}

export default PeriodDates;
